import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const LocationFilledGlyph = /*#__PURE__*/createElement("g", {
  id: "location_filled"
}, /*#__PURE__*/createElement("path", {
  d: "M65.6,37.7C65.6,24.6,55,14,42,14c-13,0-23.6,10.6-23.6,23.6c0,9,7.5,16.9,9.8,19.1l0,0c0,0,0,0,0,0l12.7,12.7 c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4l12.7-12.7l0,0C58,55.1,65.6,47.7,65.6,37.7z M49.9,45.2c-4.2,4.2-11,4.2-15.1,0 c-4.2-4.2-4.2-11,0-15.1c2.1-2.1,4.8-3.1,7.6-3.1s5.5,1,7.6,3.1C54.1,34.3,54.1,41,49.9,45.2z"
}));
const LocationFilled = createSvg({
  name: 'location_filled',
  path: LocationFilledGlyph
});

export default LocationFilled;
export { LocationFilledGlyph };
